import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <RouteState role="status">Preparando tu espacio…</RouteState>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user?.onboardingPending && location.pathname !== '/welcome') {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}

export default PrivateRoute;

const RouteState=({children,...props})=><div {...props} style={{minHeight:'60vh',display:'grid',placeItems:'center',background:'#f7f5ef',color:'#52676c',fontWeight:750}}>{children}</div>;
